import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '../services/analytics';

/**
 * Global analytics bridge:
 *   - Boots GA once on mount (idempotent inside `initGA`)
 *   - Fires a `page_view` on every route change so client-side navigation
 *     is captured, not just full page loads.
 *
 * Render this once inside <BrowserRouter> in App.js.
 * Returns null — it's an effect-only component.
 */
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => { initGA(); }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
